
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.395 17.78l-1.41 1.41-7.98-7.98-7.99 7.98-1.41-1.41 7.99-7.98-7.58-7.58L2.425.81l7.58 7.58 7.57-7.58 1.41 1.41-7.57 7.58 7.98 7.98z"}})])
          )
        }
      }
    